module.exports = __webpack_public_path__ + "img/swap.647d0438.svg";